import React, { useState } from 'react';

const FormArea = () => {
    // State to hold form data
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: ''
    });

    // State for UI feedback
    const [status, setStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus('Sending...');

        try {
            // UPDATED: Pointing to the new Vercel serverless function
            const response = await fetch('/api/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (data.success) {
                setStatus('Message Sent Successfully!');
                // Clear the form
                setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
            } else {
                setStatus('Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('Error:', error);
            setStatus('An error occurred. Make sure your local server is running.');
        } finally {
            setIsSubmitting(false);
            
            // Clear the status message after 5 seconds
            setTimeout(() => setStatus(''), 5000);
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6 mb-25">
                        <div className="contact__form-area-item">
                            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" required />
                        </div>
                    </div>
                    <div className="col-md-6 mb-25">
                        <div className="contact__form-area-item">
                            <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" required />
                        </div>
                    </div>
                    <div className="col-md-6 md-mb-25">
                        <div className="contact__form-area-item">
                            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" required />
                        </div>
                    </div>
                    <div className="col-md-6 mb-25">
                        <div className="contact__form-area-item">
                            <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject" />
                        </div>
                    </div>
                    <div className="col-md-12 mb-25">
                        <div className="contact__form-area-item">
                            <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Message" required></textarea>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="contact__form-area-item" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <button className="build_button" type="submit" disabled={isSubmitting}>
                                {isSubmitting ? 'Sending...' : 'Submit Message'} <i className="flaticon-right-up"></i>
                            </button>
                            
                            {/* Status Message Display */}
                            {status && (
                                <span style={{ 
                                    color: status.includes('Successfully') ? '#28a745' : '#dc3545', 
                                    fontWeight: '500' 
                                }}>
                                    {status}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </form>          
        </>
    );
};

export default FormArea;